import styled from "styled-components";
import { useRef, useState } from "react";

import { ComplexFilterType } from "interfaces/filters";

import { useOnClickOutside } from "hooks/useOnClickOutside";
import { MAIN_THEME } from "styles/colors";

const Button = styled.div`
	padding: 0 16px;
	display: flex;
	transition: all 0.3s ease;
	cursor: pointer;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 6px;
	background: ${MAIN_THEME.DARK_BG_TERTIARY};
	border: 1px solid ${MAIN_THEME.BORDER_COLOR};
	color: ${MAIN_THEME.TEXT_PRIMARY};
	font-size: 14px;
	font-weight: 500;

		&:hover {
			border-color: ${MAIN_THEME.SECONDARY};
			box-shadow: 0 0 10px rgba(0, 217, 255, 0.2);
		}

	@media (max-width: 768px) {
		padding: 0 12px;
		font-size: 13px;
		width: 100%;
	}
`;

const Container = styled.div`
	position: relative;
`;

const DropDownOption = styled.button`
	font-size: 14px;
	padding: 0 16px;
	background: transparent;
	border: none;
	outline: none;
	height: 32px;
	line-height: 32px;
	cursor: pointer;
	width: 100%;
	text-align: left;
	color: ${MAIN_THEME.TEXT_PRIMARY};
	transition: all 0.2s ease;

		&:hover {
			background: rgba(0, 217, 255, 0.1);
			color: ${MAIN_THEME.SECONDARY};
		}

	@media (max-width: 768px) {
		font-size: 13px;
		height: 28px;
		line-height: 28px;
	}
`;

const DropDownContainer = styled.div`
	width: 280px;
	position: absolute;
	top: 35px;
	left: 0;
	box-shadow: 0 8px 25px rgba(0, 217, 255, 0.15);
	background: ${MAIN_THEME.DARK_BG_TERTIARY};
	border: 1px solid ${MAIN_THEME.BORDER_COLOR};
	padding: 8px 0;
	border-radius: 6px;
	z-index: 100;

	@media (max-width: 768px) {
		width: 100%;
		top: auto;
		bottom: 35px;
		left: 0;
	}
`;

interface Props {
	onCreate: (type: ComplexFilterType) => void;
	options: ComplexFilterType[];
}

const AddNewFilterButton = (props: Props): JSX.Element => {
	const [isDropdownVisible, setDropdownVisible] = useState(false);

	const { onCreate, options } = props;

	const dropDownRef = useRef(null);

	useOnClickOutside(dropDownRef, () => {
		setDropdownVisible(false);
	});

	const getOptionTitle = (option: ComplexFilterType) => {
		switch (option) {
			case ComplexFilterType.CHANNEL:
				return "Channel";
			case ComplexFilterType.DATE:
				return "Date";
			case ComplexFilterType.PROPERTY_ID:
				return "Property";
			case ComplexFilterType.STATUS:
				return "Status";
			case ComplexFilterType.CITY:
				return "City";
			default:
				return "";
		}
	};

	const renderDropdown = () => (
		<DropDownContainer ref={dropDownRef}>
			{options.map((option) => (
				<DropDownOption
					key={option}
					onClick={() => {
						onCreate(option);
						setDropdownVisible(false);
					}}
				>
					{getOptionTitle(option)}
				</DropDownOption>
			))}
		</DropDownContainer>
	);

	return (
		<Container>
			<Button onClick={() => setDropdownVisible(true)}>+ Filter</Button>
			{isDropdownVisible ? renderDropdown() : null}
		</Container>
	);
};

export default AddNewFilterButton;
